import { Filter, CheckCircle, XCircle, Image, Instagram, Zap } from 'lucide-react';

export const ModerationDeck = ({ photos, filterPending, setFilterPending, handleModeration }) => (
  <div className="border border-[#00ff41]/20 rounded-lg p-6 bg-black/30">
    <div className="flex items-center justify-between mb-6">
      <h2 className="text-2xl font-semibold text-[#00ff41]">fanZcam MODERATION DECK</h2>
      <button
        onClick={() => setFilterPending(!filterPending)}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-all ${filterPending ? 'bg-[#00ff41]/20 border-[#00ff41] text-[#00ff41]' : 'bg-transparent border-gray-600 text-gray-400 hover:border-[#00ff41] hover:text-[#00ff41]'}`}
        data-testid="filter-toggle"
      >
        <Filter className="w-4 h-4" />
        {filterPending ? 'Showing Pending Only' : 'Showing All Photos'}
      </button>
    </div>
    {photos.length === 0 ? (
      <div className="text-center py-12 text-gray-500" data-testid="no-photos-message">
        <Image className="w-16 h-16 mx-auto mb-4 opacity-30" />
        <p>No photos to display</p>
      </div>
    ) : (
      <div className="terminal-grid" data-testid="photos-grid">
        {photos.map((photo) => (
          <div key={photo.id} className="photo-card bg-black/50 border border-gray-700 rounded-lg overflow-hidden" data-testid={`photo-card-${photo.id}`}>
            <img src={photo.photo_url} alt="Fan upload" className="w-full h-40 object-cover" onError={(e) => { e.target.src = 'https://via.placeholder.com/200x200/0a0a0a/00ff41?text=No+Image'; }} />
            <div className="p-3">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-gray-500">ID: {photo.id}</span>
                  {photo.instagram_shared && <Instagram className="w-3.5 h-3.5 text-[#ff0095]" fill="#ff0095" title="Shared on Instagram" />}
                </div>
                <div className="flex items-center gap-1">
                  {photo.priority === 'high' && (
                    <span className="flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-[#00ff41]/20 text-[#00ff41] font-semibold"><Zap className="w-3 h-3" />HIGH</span>
                  )}
                  <span className={`text-xs px-2 py-1 rounded ${photo.status === 'approved' ? 'bg-[#00ff41]/20 text-[#00ff41]' : photo.status === 'rejected' ? 'bg-[#ff0033]/20 text-[#ff0033]' : 'bg-gray-700 text-gray-300'}`}>
                    {photo.status.toUpperCase()}
                  </span>
                </div>
              </div>
              <div className="flex gap-2 mt-3">
                <button onClick={() => handleModeration(photo.id, 'approved')} className="flex-1 bg-[#00ff41]/20 hover:bg-[#00ff41]/30 text-[#00ff41] py-2 px-3 rounded-lg flex items-center justify-center gap-1 text-sm font-semibold transition-all border border-[#00ff41]/40" data-testid={`approve-btn-${photo.id}`} disabled={photo.status === 'approved'}>
                  <CheckCircle className="w-4 h-4" />Approve
                </button>
                <button onClick={() => handleModeration(photo.id, 'rejected')} className="flex-1 bg-[#ff0033]/20 hover:bg-[#ff0033]/30 text-[#ff0033] py-2 px-3 rounded-lg flex items-center justify-center gap-1 text-sm font-semibold transition-all border border-[#ff0033]/40" data-testid={`reject-btn-${photo.id}`} disabled={photo.status === 'rejected'}>
                  <XCircle className="w-4 h-4" />Nuke
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
